import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ChangePassword from "./pages/auth/ChangePassword";

import CommitteeList from "./pages/committee/CommitteeList";
import EventsList from "./pages/events/EventsList";
import GalleryList from "./pages/gallery/GalleryList";
import GalleryImages from "./pages/gallery/GalleryImages";
import SponsorsList from "./pages/sponsors/SponsorsList";

import MembershipList from "./pages/members/MembershipList";
import DonationList from "./pages/donations/DonationList";
import ContactMessages from "./pages/contact/ContactMessages";

import SponsorTiers from "./pages/tiers/SponsorTiers";
import MembershipTypes from "./pages/tiers/MembershipTypes";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {

  return (

    <BrowserRouter>

      <Routes>

        <Route path="/" element={<Login />} />

        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/change-password" element={
          <ProtectedRoute>
            <Layout>
              <ChangePassword />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/committee" element={
          <ProtectedRoute>
            <Layout>
              <CommitteeList />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/events" element={
          <ProtectedRoute>
            <Layout>
              <EventsList />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/gallery" element={
          <ProtectedRoute>
            <Layout>
              <GalleryList />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/gallery/:id" element={
          <ProtectedRoute>
            <Layout>
              <GalleryImages />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/sponsors" element={
          <ProtectedRoute>
            <Layout>
              <SponsorsList />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/sponsor-tiers" element={
          <ProtectedRoute>
            <Layout>
              <SponsorTiers />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/membership-types" element={
          <ProtectedRoute>
            <Layout>
              <MembershipTypes />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/memberships" element={
          <ProtectedRoute>
            <Layout>
              <MembershipList />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/donations" element={
          <ProtectedRoute>
            <Layout>
              <DonationList />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/messages" element={
          <ProtectedRoute>
            <Layout>
              <ContactMessages />
            </Layout>
          </ProtectedRoute>
        } />

      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />

    </BrowserRouter>

  );

}

export default App;